<template>
    <div style="background-color: white">
        <van-cell-group>
            <div style="display: flex; justify-content: space-between; align-items: center; padding: 20px 20px; border-bottom: 1px #F1F1F1 solid;">
                <van-image round :src="info.imageUrl" width="50px" height="50px" />
                <div style="flex: 1; margin-left:12px; display: flex; flex-direction: column; align-items: start;">
                    <div style="color: #333333; font: 14px normal;">{{info.userName}}</div>
                    <div style="color: #999999; font-size: 14px;">{{'心智宝' + info.city + '大使'}}</div>
                </div>
            </div>
            <van-cell title="认证情况" :value="info.userCard ? '已认证' : '未认证'" />
            <van-cell title="服务地区" :value="info.city" />
            <van-cell title="服务经验" :value="info.participateTime + '年'" />
            <van-cell title="联系方式" :value="info.userPhone" />
            <div style="margin: 15px 20px; padding-bottom: 10px; color: #666666; font-size: 14px;">
                <div v-html="info.userIntroduce" style="font-size: 14px;" />
            </div>
        </van-cell-group>
    </div>
</template>

<script>

    import Vue from 'vue';
    import { Cell, CellGroup } from 'vant';
    import {wxChatShare} from '@/utils/wxShare'
    import Cookies from 'js-cookie'

    Vue.use(Cell).use(CellGroup);

    export default {
        name: "AmbassadorDetail",
        data() {
            return {
                id: this.$route.query.id,
                info: {},
                user: this.$store.state.user.user,
                type: Cookies.get('type'),
            }
        },
        created() {
            this.$axios.get("/ambassador/info", {params: {id: this.id}}).then(res => {
                this.info = res.data
                this.settingShare()
            });
            if (this.$route.query.shareId) {
                this.$axios.get("/love/viewShare", {params:{userId: this.$route.query.shareId}})
            }
        },
        mounted(){
            if (window.history && window.history.pushState) {
                history.pushState(null, null, document.URL);
                window.addEventListener('popstate', this.goBack, false);
            }
        },
        destroyed(){
            window.removeEventListener('popstate', this.goBack, false);
        },
        methods: {
            goBack(){
                this.$router.replace({path: '/'});
                //replace替换原路由，作用是避免回退死循环
            },
            settingShare() {
                let name = this.user.userName || this.user.loginName
                let title = ' 向您推荐益+普惠保险综合服务平台'
                let param = {
                    url: window.location.href.split('#')[0], // 当前页面url
                    title: "【" + name + "】"  + title, // 分享数据配置 主标题
                    desc: '研究倡导 | 金融教育 | 产品研发 | 公益金融', // 分享数据配置 副标题
                    link: process.env.VUE_APP_SHARE_URL + '/ambassadorDetail?id=' + this.id + '&shareId=' + this.user.userId + '&type=' + this.type, // 分享数据配置
                    imgUrl: this.type === '0' ? 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/test/20191014/6aed3c925c527abe74487e7eb20e55ef.png' : 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/test/20191014/bd566fab0695a0256be7958b58f47bd4.png', // 分享数据配置 －－ 全路径
                    type: "link", // 分享类型,music、video或link，不填默认为link
                    dataUrl: " ", // 如果type是music或video，则要提供数据链接，默认为空
                }
                wxChatShare(param);
            },
        }
    }
</script>

<style scoped>

</style>
